export const AVAILABLE_CONSENT_KEYS = ['privacy', 'marketing', 'allJobs', 'disclosure'];
